import { createReducer } from '../../../store.model';

import { ActionType } from './chat-menu-dialog.action';
import { ChatMenuDialogState, defaultState } from './chat-menu-dialog.state';
import { MinMax } from './state/min-max.action';
import { minMaxReducer } from './state/min-max.reducer';
import { Navigate } from './state/navigate.action';
import { navigateReducer } from './state/navigate.reducer';

const { builder, reducer } = createReducer<ActionType, ChatMenuDialogState>(
    defaultState(),
);

builder.add<Navigate>(ActionType.TC__CM__NAVIGATE, navigateReducer);

builder.add<MinMax>(ActionType.TC__CM__MIN_MAX, minMaxReducer);

export const chatMenuDialogReducer = reducer;
